import { render, staticRenderFns } from "./faqs.vue?vue&type=template&id=c52f5158&scoped=true"
import script from "./faqs.vue?vue&type=script&lang=js"
export * from "./faqs.vue?vue&type=script&lang=js"
import style0 from "./faqs.vue?vue&type=style&index=0&id=c52f5158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52f5158",
  null
  
)

export default component.exports